
import { hPost } from '@osgfe/tools';

export const API_LIST = {
    //  供应商当前入驻状态接口
    GET_MERCHANT_STATE: '/api/vss/shepherd/sqm/merchantsSupplier/getMerchantState',
    // 查询商家账号信息
    GET_BIZ_ACCOUNT_INFO: '/api/vss/shepherd/account/getBizAccountInfo',
};

// 获取供应商入驻状态
export const getMerchantStateApi = (params) => hPost(API_LIST.GET_MERCHANT_STATE, params);
// 获取商家账号信息
export const getBizAccountApi = (options) => hPost(API_LIST.GET_BIZ_ACCOUNT_INFO, {}, { cache: true, ...options });
